import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MDEditor from "@uiw/react-md-editor";
import "./EditSingleArticle.css";





const EditSingleArticle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [mainImage, setMainImage] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/articles/${id}`);
        const data = await res.json();

        setTitle(data.title);
        setContent(data.content);
        setMainImage(data.mainImage);
        setDate(data.date.split("T")[0]);
      } catch (err) {
        console.error("Erreur chargement article:", err);
      }
    };

    fetchArticle();
  }, [id]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/articles/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ title, content, mainImage, date })
      });

      if (res.ok) {
        navigate("/admin/articles");
      } else {
        console.error("Erreur mise à jour");
      }
    } catch (err) {
      console.error("Erreur requête PUT:", err);
    }
  };

  return (
    <div className="edit-article-page">
      <h2>Modifier l'article</h2>
      <form onSubmit={handleUpdate} className="edit-article-form">
        <label>Titre :</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} required />

        <label>Image principale (URL) :</label>
        <input value={mainImage} onChange={(e) => setMainImage(e.target.value)} required />

        <label>Date :</label>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} required />

        <label>Contenu :</label>
        <div className="editor-container">
          <MDEditor value={content} onChange={setContent} height={400} />
        </div>

        <button type="submit">Enregistrer les modifications</button>
      </form>
    </div>
  );
};

export default EditSingleArticle;
